import request from '../request'
import requestUrl from '../requestUrl'
import requestParam from '../requestParam'

/**
 * 查询 queryKPMG roles list
 * @param {*} s
 */
export const querySite = (params) => {
    return request({
        url: requestUrl('/client/site/queryHomeSites'),
        method: 'post',
        data: requestParam(params)
    })
}
/**
 * 查询 query siteInfo by engagementCode
 * @param {*} s
 */
export const querySiteInfo = (params) => {
    return request({
        url: requestUrl('/client/site/querySiteInfo'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询 siteInfo by siteId
 * @param {*} s
 */
export const querySiteInfoBySiteId = (params) => {
    return request({
        url: requestUrl('/site/member/getSiteById'),
        method: 'post',
        data: requestParam(params)
    })
}

export const saveQueryParam = (params) => {
    return request({
        url: requestUrl('/user/saveQueryParam'),
        method: 'post',
        data: requestParam(params)
    })
}

export const getUserSiteAuthorityInfo = (params) => {
    return request({
        url: requestUrl('/user/getUserAccessType'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 站点卡片悬浮内容
 * @param {*} s
 */
export const querySiteUsageData = (params) => {
    return request({
        url: requestUrl('/site/querySiteUsageData'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 用户点击卡片
 * @param {*} s
 */
export const siteClick = (params) => {
    return request({
        url: requestUrl('/client/site/click'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updatePinStatus = (params) => {
    return request({
        url: requestUrl('/client/site/pin'),
        method: 'post',
        data: requestParam(params)
    })
}


